import React, { FC } from 'react';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import { getYear, format, Locale } from 'date-fns';

// Components
import { Icon } from '../../common';

interface Props extends ReactDatePickerCustomHeaderProps {
  locale: Locale;
}

const FormikDatePickerHeader: FC<Props> = ({
  date,
  decreaseYear,
  increaseYear,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  locale,
}) => {
  return (
    <div className="aea-form-datepicker-header-custom">
      <div className="aea-form-datepicker-header-custom__section aea-datepicker-header-custom__section-first">
        <span>{getYear(date)}</span>
      </div>
      <div className="aea-form-datepicker-header-custom__section">
        {!prevMonthButtonDisabled ? (
          <button type="button" onClick={decreaseMonth}>
            <Icon
              className="aea-form-icon aea-form-icon--md color-green-dark"
              type="chevronLeftFilled"
            />
          </button>
        ) : (
          <button type="button">
            <Icon
              className="aea-form-icon aea-form-icon--md color-gray-light"
              type="chevronLeftFilled"
            />
          </button>
        )}

        <span>{format(date, 'LLLL', { locale: locale })}</span>

        {!nextMonthButtonDisabled ? (
          <button type="button" onClick={increaseMonth}>
            <Icon
              className="aea-form-icon aea-form-icon--md color-green-dark"
              type="chevronRightFilled"
            />
          </button>
        ) : (
          <button type="button">
            <Icon
              className="aea-form-icon aea-form-icon--md color-gray-light"
              type="chevronRightFilled"
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default FormikDatePickerHeader;
